export enum StatusTyp {
  OFFEN = 'offen',
  GELESEN = 'erledigt/gelesen',
}
